export default __webpack_public_path__ + "static/media/hbs-bpk-banner-1.2dad2c98.jpg";